import { createSlice } from "@reduxjs/toolkit";
import * as moduleConstants from "./constants";

const initialListingsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  listingForEdit: undefined,
  lastError: null,
  queryParams: {},
  filters: {},
  searchColumns: moduleConstants.searchColumns,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const slice = createSlice({
  name: moduleConstants.SLICE,
  initialState: { ...initialListingsState },
  extraReducers: (builder) => {
    builder.addCase("[Auth] Logout Action", (state, action) => {
      return { ...initialListingsState };
    });

    builder.addCase("ClearMainFilters", (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = null;
      state.listingForEdit = undefined;
      state.lastError = null;
      state.queryParams = {};
      state.filters = {};
      state.searchColumns = moduleConstants.searchColumns;

      return state;
    });
  },
  reducers: {
    reset: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = null;
      state.listingForEdit = undefined;
      state.lastError = null;
      state.queryParams = {};
      state.filters = {};
      state.searchColumns = moduleConstants.searchColumns;
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    listingFetched: (state, action) => {
      state.actionsLoading = false;
      state.listingForEdit = action.payload.listingForEdit;
      state.error = null;
    },

    listingsFetched: (state, action) => {
      var { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    setFilters: (state, action) => {
      state.listLoading = false;
      if (action.payload["filters"]) {
        state.filters = { ...action.payload["filters"] };
      }
    },

    setSearchColumns: (state, action) => {
      if (action.payload["searchColumns"]) {
        state.searchColumns = { ...action.payload["searchColumns"] };
      }
    },
  },
});
